// extracted by mini-css-extract-plugin
export default {"container":"_20m2bjP34vS3Syt7joC_dE"};